import { IDeleteDisciplinasArquivosUseCase } from "../../../presentation/useCases/delete/delete_disciplinas_arquivos_use_case";
import { DeleteDisciplinasArquivosRequestModel, DeleteDisciplinasArquivosResponseModel } from "../../models/disciplina_arquivo_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DeleteDisciplinasArquivosUseCase
 */

export class DeleteDisciplinasArquivosUseCase implements IDeleteDisciplinasArquivosUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteDisciplinasArquivos(model: DeleteDisciplinasArquivosRequestModel): Promise<DeleteDisciplinasArquivosResponseModel> {
    return await this.repository.deleteDisciplinaArquivo(model);
  }
}
